(function () {
  document.querySelectorAll('[data-routed-product]').forEach(initProduct);
  document.querySelectorAll('[data-routed-related]').forEach(initRelatedCarousel);

  function initProduct(section) {
    const form = section.querySelector('[data-product-form]');
    const variantInput = section.querySelector('[data-variant-input]');
    const priceContainer = section.querySelector('[data-product-price]');
    const atcButton = section.querySelector('[data-atc-button]');
    const atcText = section.querySelector('[data-atc-text]');
    const radios = section.querySelectorAll('[data-option-radio]');
    const selectedDisplays = section.querySelectorAll('[data-selected-value]');
    const variantsScript = section.querySelector('[data-product-variants]');
    const mediaMapScript = section.querySelector('[data-product-media-map]');
    const slides = section.querySelectorAll('[data-slide]');
    const thumbs = section.querySelectorAll('[data-thumb]');
    const prevBtn = section.querySelector('[data-gallery-prev]');
    const nextBtn = section.querySelector('[data-gallery-next]');

    if (!form || !variantInput) return;

    let variants = [];
    let mediaMap = { media: [], variantMedia: {} };
    try {
      variants = JSON.parse(variantsScript.textContent);
      mediaMap = JSON.parse(mediaMapScript.textContent);
    } catch (e) {
      console.error('[Routed Product] Variant data parse error', e);
      return;
    }

    let currentIndex = 0;

    // ----- Gallery -----
    function goToSlide(index) {
      if (index < 0 || index >= slides.length) return;
      slides.forEach((s) => s.classList.remove('is-active'));
      thumbs.forEach((t) => t.classList.remove('is-active'));
      slides[index].classList.add('is-active');
      if (thumbs[index]) thumbs[index].classList.add('is-active');
      currentIndex = index;
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const idx = parseInt(thumb.dataset.mediaIndex, 10);
        if (!isNaN(idx)) goToSlide(idx);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', () => goToSlide(currentIndex - 1 < 0 ? slides.length - 1 : currentIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goToSlide(currentIndex + 1 >= slides.length ? 0 : currentIndex + 1));

    // ----- Variant selection -----
    function getSelectedOptions() {
      const options = [];
      const groups = section.querySelectorAll('[data-option-index]');
      groups.forEach((group) => {
        const idx = parseInt(group.dataset.optionIndex, 10);
        const checked = group.querySelector('input[type="radio"]:checked');
        if (checked) options[idx] = checked.value;
      });
      return options;
    }

    function findMatchingVariant(selectedOpts) {
      return variants.find((v) => {
        return v.options.every((opt, i) => opt === selectedOpts[i]);
      });
    }

    function updateUI(variant) {
      if (!variant) {
        atcButton.disabled = true;
        atcText.textContent = 'Unavailable';
        return;
      }

      // Update hidden variant ID
      variantInput.value = variant.id;

      // Update price
      const priceHTML = buildPriceHTML(variant);
      priceContainer.innerHTML = priceHTML;

      // Update ATC button
      if (variant.available) {
        atcButton.disabled = false;
        atcText.textContent = `Add to Cart — ${formatMoney(variant.price)}`;
      } else {
        atcButton.disabled = true;
        atcText.textContent = 'Sold Out';
      }

      // Update selected value displays
      selectedDisplays.forEach((display, i) => {
        if (variant.options[i] != null) {
          display.textContent = variant.options[i];
        }
      });

      // Swap to variant's image if it has one
      const variantMediaIdx = mediaMap.variantMedia[variant.id];
      if (variantMediaIdx != null) {
        goToSlide(variantMediaIdx);
      }

      // Update URL without reload
      try {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } catch (e) {
        // ignore
      }
    }

    function updateRadioAvailability(selectedOpts) {
      // For each option group, disable values that produce 0 available variants
      const groups = section.querySelectorAll('[data-option-index]');
      groups.forEach((group) => {
        const idx = parseInt(group.dataset.optionIndex, 10);
        const radios = group.querySelectorAll('input[type="radio"]');
        radios.forEach((radio) => {
          const testOpts = [...selectedOpts];
          testOpts[idx] = radio.value;
          // A value is available if there's at least one variant matching the test opts that's available
          const matches = variants.filter((v) => {
            return v.options.every((opt, i) => {
              if (i === idx) return opt === radio.value;
              if (testOpts[i] == null) return true;
              return opt === testOpts[i];
            });
          });
          const anyAvailable = matches.some((v) => v.available);
          radio.disabled = !anyAvailable;
        });
      });
    }

    function onRadioChange() {
      const selectedOpts = getSelectedOptions();
      const variant = findMatchingVariant(selectedOpts);
      updateUI(variant);
      updateRadioAvailability(selectedOpts);
    }

    radios.forEach((radio) => {
      radio.addEventListener('change', onRadioChange);
    });

    // Run once on load to set initial disabled states
    updateRadioAvailability(getSelectedOptions());

    // ----- Quantity stepper -----
    const qtyDec = section.querySelector('[data-qty-decrease]');
    const qtyInc = section.querySelector('[data-qty-increase]');
    const qtyInput = section.querySelector('[data-qty-input]');

    if (qtyDec && qtyInc && qtyInput) {
      qtyDec.addEventListener('click', () => {
        const current = parseInt(qtyInput.value, 10) || 1;
        if (current > 1) qtyInput.value = current - 1;
      });
      qtyInc.addEventListener('click', () => {
        const current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = current + 1;
      });
      qtyInput.addEventListener('change', () => {
        const val = parseInt(qtyInput.value, 10);
        if (isNaN(val) || val < 1) qtyInput.value = 1;
      });
    }

    // ----- Add to cart -----
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (atcButton.disabled) return;

      atcButton.classList.add('is-loading');
      const originalText = atcText.textContent;
      atcText.textContent = 'Adding...';

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/javascript' }
        });

        if (!response.ok) throw new Error('Add to cart failed');

        const result = await response.json();
        atcText.textContent = 'Added ✓';

        // Open cart drawer (the cart drawer JS listens for this event)
        document.dispatchEvent(new CustomEvent('routed:cart:added', { detail: result }));

        setTimeout(() => {
          atcText.textContent = originalText;
          atcButton.classList.remove('is-loading');
        }, 1500);

      } catch (err) {
        console.error('[Routed Product] ATC error', err);
        atcText.textContent = 'Try again';
        atcButton.classList.remove('is-loading');
        setTimeout(() => {
          atcText.textContent = originalText;
        }, 2000);
      }
    });

    // ----- Helpers -----
    function buildPriceHTML(variant) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        return `<span class="routed-product__price-current routed-product__price-current--sale">${formatMoney(variant.price)}</span><s class="routed-product__price-compare">${formatMoney(variant.compare_at_price)}</s>`;
      }
      return `<span class="routed-product__price-current">${formatMoney(variant.price)}</span>`;
    }

    function formatMoney(cents) {
      const dollars = (cents / 100).toFixed(2);
      return `$${dollars}`;
    }
  }

  function initRelatedCarousel(section) {
    const carousel = section.querySelector('[data-related-carousel]');
    const prevBtn = section.querySelector('[data-related-prev]');
    const nextBtn = section.querySelector('[data-related-next]');
    if (!carousel) return;

    function scrollByAmount(direction) {
      const item = carousel.querySelector('.routed-related__item');
      if (!item) return;
      const itemWidth = item.offsetWidth + 20; // include gap (1.25rem = 20px)
      carousel.scrollBy({ left: itemWidth * direction, behavior: 'smooth' });
    }

    function updateNavButtons() {
  if (!prevBtn || !nextBtn) return;
  // Hide arrows entirely if everything fits in the viewport
  const isScrollable = carousel.scrollWidth > carousel.clientWidth + 4;
  if (!isScrollable) {
    prevBtn.style.display = 'none';
    nextBtn.style.display = 'none';
    return;
  }
  prevBtn.style.display = '';
  nextBtn.style.display = '';
  prevBtn.disabled = carousel.scrollLeft <= 0;
  nextBtn.disabled = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 4;
}

    if (prevBtn) prevBtn.addEventListener('click', () => scrollByAmount(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => scrollByAmount(1));

    carousel.addEventListener('scroll', updateNavButtons);
    window.addEventListener('resize', updateNavButtons);
    updateNavButtons();
  }
})();